import type {TicketStatus} from '../types/ticket';

/**
 * The order a queue is read in, and therefore the order a status menu offers.
 *
 * Named once so the list's grouping and the Details panel's menu can never disagree
 * about which status comes first.
 */
export const STATUS_ORDER: readonly TicketStatus[] = ['open', 'in_progress', 'waiting_on_customer', 'resolved', 'closed'];

/**
 * The statuses that mean the work left the queue. `resolved` and `closed` are
 * distinct states but both are settled, so both count — this is what "% resolved",
 * the resolved-view column promotion and the SLA achievement rate all read.
 *
 * Named here rather than in each caller so a dashboard subtotal, a totals row and
 * a column default can never disagree about what "resolved" means.
 */
export const RESOLVED_STATUSES: readonly TicketStatus[] = ['resolved', 'closed'];

/**
 * Whether a ticket's status means it has left the queue.
 *
 * Takes a plain `string` so the filter state — which carries status ids as strings,
 * since they arrive from URL params and checkbox values — can ask without a cast.
 */
export function isResolvedStatus(status: string): boolean {
	return (RESOLVED_STATUSES as readonly string[]).includes(status);
}
